import {Button, FieldError, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface WelcomeAvatarHintProps {
  hasAvatar: boolean;
  error?: string;
  isDisabled: boolean;
  onUpload: () => void;
  onRemove: () => void;
}

export const WelcomeAvatarHint: FC<WelcomeAvatarHintProps> = ({
  hasAvatar,
  error,
  isDisabled,
  onUpload,
  onRemove
}) => {
  const {t} = useTranslation('settings');

  return (
    <div data-slot="welcome-avatar-hint" className="flex flex-col items-center gap-1">
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="linkColor"
          size="xs"
          className="px-0"
          disabled={isDisabled}
          onClick={onUpload}
        >
          {t('accountModal.welcome.avatarUpload')}
        </Button>
        <Typography size="xs" color="tertiary">
          {t('accountModal.welcome.avatarHint')}
        </Typography>
        {hasAvatar && (
          <Button
            type="button"
            variant="linkColor"
            destructive
            size="xs"
            className="px-0"
            disabled={isDisabled}
            onClick={onRemove}
          >
            {t('accountModal.avatar.remove')}
          </Button>
        )}
      </div>
      {error && <FieldError className="whitespace-normal text-center">{error}</FieldError>}
    </div>
  );
};
